module.exports = __webpack_public_path__ + "media/images/readers-landing-page-9fab891c7db356faab62759993222a71.jpg";